<template>
    <div class="request-based-on" v-if="sourceId">
        <span>
            Создано на основе обращения
            <router-link v-if="canView" class="request-based-on__number" :to="sourceLink">№{{ sourceId }}</router-link>
            <strong v-else>№{{ sourceId }}</strong>
        </span>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { getRequestBasedOn } from '@/js/api';

@Component
class RequestViewBasedOn extends Vue {
    @Prop({ type: Object, required: true }) request;
    sourceId = null;
    canView = false;
    token = 0;

    get sourceLink() {
        return { name: 'request', params: { method: this.$route.params.method || 'outbox', id: this.sourceId } };
    }

    async load() {
        const token = ++this.token;
        this.sourceId = null;
        this.canView = false;
        try {
            const { data } = await getRequestBasedOn(this.request.id);
            if (token === this.token) {
                this.sourceId = data.id;
                this.canView = data.canView;
            }
        } catch (error) {
            // The origin may have been removed while the card was open.
        }
    }

    @Watch('request.id')
    onRequestChange() {
        this.load();
    }
    mounted() {
        this.load();
    }
}

export default RequestViewBasedOn;
</script>
<style lang="scss">
.request-based-on {
    padding: 10px 16px;
    color: #484848;
    font-size: 0.875rem;
    background: #fff8e6;
    border: 1px solid #f3dfa8;
    border-radius: 12px;

    &__number {
        color: #1a73e8;
        font-weight: 600;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
